import { Stack, Card, CardHeader, IconButton, Box } from '@mui/material';
import {
    TypographyTitle,
} from '../style/typography'
import {
    BoxCenterStart,
    CardContentNoPadding
} from '../style/box'

export default function ColorCard(props) {
    return (
        <Card variant="outlined"
            sx={{
                backgroundColor: props.bgColor
                // height: { xs: props.xsHeight, sm: props.height }
            }}>
            <CardHeader sx={{ padding: '0px' }}
                titleTypographyProps={{
                    sx: {
                        color: props.fontColor,
                        fontSize: { xs: '0.75rem', sm: '0.75rem', md: 'clamp(0.375rem, -0.3rem + 1.2vw, 0.75rem)' },
                        fontWeight: 'bold',
                        backgroundColor: props.bgColor,
                        padding: '3px',
                    }
                }}
                title={props.title}
            />
            <CardContentNoPadding>
                <Stack height={{ xs: props.xsHeight, sm: props.height }} width={'100%'}>
                        {props.child}
                </Stack>
            </CardContentNoPadding>
        </Card>
    )
};
